import { Skeleton as PRSkeleton } from 'primereact/skeleton';
import { twMerge } from 'tailwind-merge';

export default function Skeleton({ width, height, className }) {
  return (
    <PRSkeleton
      width={width}
      height={height}
      className={twMerge(
        'bg-gray-300 after:absolute after:top-0 after:left-0 after:right-0 after:bottom-0 after:content after:w-full after:h-full after:left-full after:transform after:translate-x-full after:z-10 after:bg-gradient-to-r after:from-transparent after:via-white after:to-transparent animate-pulse',
        className && className
      )}
    />
  );
}
